import React, { Component } from "react";

import { withFirebase } from "../Firebase";


import Select from "react-select";

import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/table/lib/css/table.css";


import {
  Button,
  InputGroup,
  Label,
  Checkbox
} from "@blueprintjs/core";

import { Grid, Row, Col } from "react-flexbox-grid";
import "./index.css";
import {  Radio, RadioGroup } from "@blueprintjs/core";
import Repeat from "react-repeat-component";
import { Form } from "react-formio";

class FormPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        display: "form",
        components: []
      },
      questions: [],
      numberOfQuestions: ""
    };
  }
  componentDidMount() {}

  render() {
    return (
      <Grid>
        <Row xs>
          <h3>Form Builder</h3>
        </Row>
        <Row xs>
          <Col>
            <RadioGroup
              inline
              label="Confirmation Type"
              name="group"
              selectedValue={this.state.confirmation_type}
              onChange={event => {
                this.setState({
                  confirmation_type: event.target.value
                });
              }}
            >
              <Radio label="Auto Confirm" value="auto_confirm" />
              <Radio label="Filter Applicants" value="filter" />
            </RadioGroup>
            {this.state.confirmation_type === "filter" ? (
              <div>
                <Repeat times={this.state.numberOfQuestions}>
                  {i => (
                    <Grid>
                      <Row>
                        <Col xs>
                          <Label>
                            Question name (for internal use)
                            <InputGroup
                              onChange={event => {
                                var questions = this.state.questions;
                                questions[i].name = event.target.value;
                                this.setState({ questions: questions });
                                console.log(this.state.questions);
                              }}
                            ></InputGroup>
                          </Label>
                        </Col>
                        <Col xs>
                          <Label>
                            Question Title
                            <InputGroup
                              onChange={event => {
                                var questions = this.state.questions;
                                questions[i].title = event.target.value;
                                this.setState({ questions: questions });
                                console.log(this.state.questions);
                              }}
                            ></InputGroup>
                          </Label>
                        </Col>
                        <Col xs>
                          <Label>
                            Question Type
                            <Select
                              options={[
                                { label: "Text", value: "textfield" },
                                {
                                  label: "Multiple Choice",
                                  value: "selectboxes"
                                },
                                { label: "Radio Button", value: "radio" }
                              ]}
                              onChange={event => {
                                var questions = this.state.questions;
                                questions[i].type = event.value;
                                questions[i].options = [
                                  { label: "", value: "" }
                                ];
                                this.setState({ questions: questions });
                                console.log(this.state.questions);
                              }}
                            ></Select>
                          </Label>
                        </Col>
                        <Label>
                          Required?
                          <Checkbox
                            onChange={event => {
                              var questions = this.state.questions;
                              questions[i].required = event.target.checked;
                              this.setState({ questions: questions });
                              console.log(this.state.questions);
                            }}
                          ></Checkbox>
                        </Label>
                      </Row>
                      <Row>
                        {this.state.questions[i].type === "textfield" ? null : (
                          <div>
                            <Row>
                              <Repeat
                                times={this.state.questions[i].options.length}
                              >
                                {j => (
                                  <Row>
                                    <Col xs>
                                      <Label>
                                        Option {j + 1} Label
                                        <InputGroup
                                          onChange={event => {
                                            var questions = this.state
                                              .questions;
                                            questions[i].options[j].label =
                                              event.target.value;
                                            this.setState({
                                              questions: questions
                                            });
                                            console.log(this.state.questions);
                                          }}
                                        ></InputGroup>
                                      </Label>
                                    </Col>
                                    <Col xs>
                                      <Label>
                                        Option {j + 1} value
                                        <InputGroup
                                          onChange={event => {
                                            var questions = this.state
                                              .questions;
                                            questions[i].options[j].value =
                                              event.target.value;
                                            this.setState({
                                              questions: questions
                                            });
                                            console.log(this.state.questions);
                                          }}
                                        ></InputGroup>
                                      </Label>
                                    </Col>
                                    <Col xs>
                                      <Button
                                        onClick={event => {
                                          var questions = this.state.questions;
                                          questions[i].options.splice(j, 1);
                                          this.setState({
                                            questions: questions
                                          });
                                          console.log(this.state.questions);
                                        }}
                                      >
                                        -
                                      </Button>
                                    </Col>
                                  </Row>
                                )}
                              </Repeat>
                            </Row>
                            <Row>
                              <Col xs>
                                <Button
                                  onClick={event => {
                                    var questions = this.state.questions;
                                    questions[i].options.push({
                                      label: "",
                                      value: ""
                                    });
                                    this.setState({
                                      questions: questions
                                    });
                                    console.log(this.state.questions);
                                  }}
                                >
                                  Add Option
                                </Button>
                              </Col>
                            </Row>
                          </div>
                        )}
                      </Row>
                    </Grid>
                  )}
                </Repeat>
                <Row>
                  <Button
                    onClick={event => {
                      var newNumber = this.state.numberOfQuestions;
                      var questions = this.state.questions;
                      questions.push({ options: [], type: "textfield" });
                      newNumber++;
                      this.setState({
                        numberOfQuestions: newNumber,
                        questions: questions
                      });
                    }}
                  >
                    Add Question
                  </Button>
                </Row>
                <Row>
                  <Button
                    onClick={event => {
                      var questions = this.state.questions;
                      var form = this.state.form;
                      questions.forEach(question => {
                        var component;
                        if (question.type === "textfield") {
                          component = {
                            input: true,
                            key: question.name,
                            label: question.title,
                            tableView: true,
                            type: question.type
                          };
                        }
                        if (question.type === "selectboxes") {
                          component = {
                            input: true,
                            inputType: "checkbox",
                            key: question.name,
                            label: question.title,
                            tableView: true,
                            type: question.type,
                            values: question.options
                          };
                        }
                        if (question.type === "radio") {
                          component = {
                            input: true,
                            key: question.name,
                            label: question.title,
                            tableView: true,
                            type: question.type,
                            values: question.options
                          };
                        }
                        form.components.push(component);
                      });
                      form.components.push({
                        disableOnInvalid: true,
                        input: true,
                        key: "submit",
                        label: "Submit",
                        tableView: true,
                        type: "button"
                      });
                      this.setState({ form: form });
                      console.log(form);
                    }}
                  >
                    Save form
                  </Button>
                </Row>
              </div>
            ) : null}
          </Col>
        </Row>
        <Row>
          <Col xs>
            <Form form={this.state.form}></Form>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default withFirebase(FormPage);
